import { ContentContainer } from "@/components/ContentContainer";
import { Button, Grid, Typography } from "@mui/material";
import Link from "next/link";

function Error({statusCode}) {
    return <>
      <ContentContainer headline={statusCode} subheadline={statusCode === 403 ? 'Forbidden' : 'Fehler'}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6} textAlign="center">
            <Typography
              variant="h3"
              component="p"
              textAlign="center"
              color="common.black"
              sx={{mb: 3}}
            >
              Hoppla. Es gab einen unerwarteten Fehler.
            </Typography>
            <Button component={Link} href="/" variant="contained" color="secondary">
              Zur Startseite
            </Button>
          </Grid>
        </Grid>
      </ContentContainer>
    </>;
}

Error.getInitialProps = ({res, err}) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return {statusCode};
};

export default Error;
